<template>
  <footer class="success-footer111">
    <div class="jkkerwet"></div>
    <div></div>
    <div class="kkkdfd555">
      <div  class="footer-left">
        <div class="footer-logo">
          <img class="knewrew1" style="width: 3.2rem;height: 3.2rem;" src="@/assets/xxkc/dibu2.png"/>
          <div class="kkkfuu">
            <p>国际数据治理协会</p>
            <p>Data Management Association International</p>
          </div>
        </div>
        <div class="footer-logo">
          <img class="knewrew2" src="@/assets/xxkc/dibu3.png"/>
          <div class="kkkfuu">
            <p>企业数据治理联盟</p>
            <p>Enterprise Data Governance Alliance</p>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-item">
          <img class="tp1"  src="@/assets/xxkc/dianhua.png"/>
          <p><strong>电话：</strong>400-155-1068</p>
        </div>
        <div class="footer-right-item">
          <img class="tp2" src="@/assets/xxkc/youxiang.png"/>
          <p><strong>邮箱：</strong>dingli@jobhand.cn</p>
        </div>
<!--        <div class="footer-right-item">-->
<!--          <img class="tp1" src="@/assets/xxkc/weizhi1.png"/>-->
<!--          <p><strong>地址：</strong>山东省济南市舜华路2000号舜泰广场2号楼16F</p>-->
<!--        </div>-->
      </div>
    </div>
    <div class="footer-copyright">
      <p>&copy;2016 <strong>企业数据治理联盟</strong> All rights reserved. 鲁ICP备15001845号</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
/* 样式代码与图像专家模型答案相同，省略 */
.success-footer111 {
  background: #1f3274;
  color: white;
  margin-top: auto;
  width: 100%;
  min-height: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-image: url('../../../assets/xxkc/footerbeijing.jpg');
  background-size: cover; /* 控制背景图尺寸 */
  background-repeat: no-repeat;
  padding:3rem 0 1rem 0;
}
.kkkdfd555{
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding:0 0 3rem 0;
}
.footer-logo {
  display: flex;
  gap: 3px;
  align-items: center;
}
.kkkfuu{
  height: 4rem;
  display: flex;
  flex-direction: column;
  padding: 5px;
  justify-content: center;
}

.footer-left{
  display: flex;
  gap:2rem;
  justify-content: space-between;
  align-items: center;
}

.footer-logo p {
  font-size: 12px;
  color: #ffffff;
}

.footer-right {
  display: inline-block;
  vertical-align: top;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-right-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.knewrew1{
  width: 4rem;
  height: 4rem;
  margin-right: 10px;
  filter: brightness(0) invert(1);
}
.knewrew2{
  width: 4rem;
  height: 4rem;
  margin-right: 10px;

}
.footer-right-item p {
  margin-top: 0;
  font-size: 12px;
  line-height: 1.2;
  color: #eaeaee;
}

.footer-copyright {
  /*width: 100%;*/
  color: #d5d5d6;
  clear: both;
  text-align: center;
  font-size: 12px;
  border-top:1px solid #445487;
  padding: 15px;
}

.footer-copyright p {
  margin: 0;
}
.tp1{
  width: 16px;height: 15px;margin-right: 10px;
}
.tp2{
  width: 15px;height: 11px;margin-right: 10px;
}
</style>
